import React, { useState, useEffect } from "react";
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Switch from '@mui/material/Switch';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import {BasicTable} from './BasicTable';
import {ColumnsMenu} from './ColumnsMenu';
import Box from '@mui/material/Box';


const CabinetTableControls = ( {cabinets, setFiltered, columns, setColumns} ) => {

  const [filters, setFilters] = useState({
    locations: true,
    risers: true,
    status: "All"
  });

  
  const statusList = [...new Set(cabinets.map(cabinet => cabinet.status))]
  
  useEffect(() => {
    filterEntryPoints();
  }, [filters])
  
  const filterEntryPoints = () => {
    setFiltered(
      cabinets
      .filter(cabinet => !cabinet.location || cabinet.in_cabinet || filters.locations)
      .filter(cabinet => !cabinet.riser || filters.risers)
      .filter(cabinet => cabinet.status === filters.status || filters.status === "All")
    )
  }
  
    
  const toggleFilter = (event) => {
    setFilters(
      {
        ...filters,
        [event.target.name]: event.target.checked,
      }
    );
  };
  
  const selectFilter = (event) => {
    setFilters(
      {
        ...filters,
        [event.target.name]: event.target.value,
      }
    );
  };

  return(
    <Box sx={{ flexGrow: 1 }}>
      <FormGroup row>
        <FormControlLabel control={
          <Switch
            checked={filters.locations}
            name="locations"
            onChange={toggleFilter}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        } label="Locations" />
        <FormControlLabel control={
          <Switch
            checked={filters.risers}
            name="risers"
            onChange={toggleFilter}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        } label="Risers" />
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="status-select-label">Status</InputLabel>
          <Select
            labelId="status-select-label"
            id="status-select"
            autoWidth
            value={filters.status}
            name="status"
            label="Status"
            onChange={selectFilter}
          >
          <MenuItem value="All" key={"all"}>All</MenuItem>
          {
            statusList.map( (x) => { 
              return(<MenuItem value={x} key={x}>{x}</MenuItem>) 
            })
          }
          </Select>
        </FormControl>
      </FormGroup>
      <ColumnsMenu columns={columns} setColumns={setColumns} />
    </Box>
  )
}


export const CabinetTable = ( props ) => {
  const [filtered, setFiltered] = useState(props.rows);
  const [columns, setColumns] = useState(props.columns);

  return (
    <>
    <CabinetTableControls 
      cabinets={props.rows} 
      setFiltered={setFiltered}
      columns={columns}
      setColumns={setColumns}
    />
    <BasicTable
      columns={columns.filter(column => column.display)}
      filtered={filtered}
    />
    </>
  )
}

